// KPI reporting: the routes and the sidebar rows of `wealth.intelligence.kpi` (ADR-0027).
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'wealth.intelligence.kpi',
    routes: [
        { frontend: 'view', path: 'kpi', lazy: () => import('@/pages/view/kpi/page') },
        {
            frontend: 'view',
            path: 'kpi/clients',
            lazy: () => import('@/pages/view/kpi/clients/page'),
        },
    ],
    nav: [
        {
            frontend: 'view',
            key: 'kpi',
            label: 'KPI',
            href: '/view/kpi',
            icon: 'Target',
            group: 'performance',
            order: 230,
        },
    ],
});
